import { render, staticRenderFns } from "./BookCentreLowStock.vue?vue&type=template&id=0d2ced53&"
import script from "./BookCentreLowStock.vue?vue&type=script&lang=js&"
export * from "./BookCentreLowStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports